import { Box, Container, Typography } from "@mui/material";
import lathe from "../assets/str.avif";
import strwork from "../assets/s.jpeg";
import superm from "../assets/super.png";
import manf from "../assets/manu.jpeg";
import pharma from "../assets/pharma.jpeg";
import refine from "../assets/refine.jpeg";

const industries = [
  {
    title: "E-Commerce",
    img: lathe,
  },
  {
    title: "Retail & Supermarkets",
    img: superm,
  },
  {
    title: "Logistics & Warehousing",
    img: strwork,
  },
  {
    title: "Manufacturing",
    img: manf
    },
  {
    title: "Healthcare & Pharma",
    img: pharma  },
  {
    title: "Food & Beverages",
    img: refine  },
];

export default function IndustriesWeServe() {
  return (
    <Box sx={{ py: 8, backgroundColor: "#f5f7fa" }}>
      <Container maxWidth="lg">
        {/* Heading */}
        <Typography
          variant="h4"
          fontWeight="900"
          sx={{
            fontWeight: 900,
            mb: 6,
            textAlign: "center",
            color: "#1a237e",
            fontSize: {
              xs: "1.5rem",
              sm: "1.3rem",
              md: "2rem",
              lg: "2rem",
            },
          }}
        >
          Industries We Serve
        </Typography>

        {/* Flex Container */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 4,
            justifyContent: "center",
          }}
        >
          {industries.map((item, index) => (
            <Box
              key={index}
              sx={{
                width: { xs: "100%", sm: "45%", md: "30%" },
                background: "#fff",
                borderRadius: 4,
                overflow: "hidden",
                boxShadow: "0px 6px 20px rgba(0,0,0,0.1)",
                transition: "all 0.35s ease",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0px 10px 28px rgba(0,0,0,0.15)",
                },
              }}
            >
              {/* Image */}
              <Box
                component="img"
                src={item.img}
                alt={item.title}
                sx={{
                  width: "100%",
                  height: 180,
                  objectFit: "cover",
                }}
              />

              {/* Title */}
              <Box sx={{ p: 2.5, textAlign: "center" }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: "#1a237e",
                  }}
                >
                  {item.title}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
